<template>
  <div class="analyzedresult">
    <b-table small :fields="fields" :items="analyzedResult.logclusters" responsive="sm">
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(log)="data">
        <b-list-group class="loglist">
          <b-list-group-item v-b-toggle="'collapse'+data.index">{{ data.item.log[0] }}</b-list-group-item>
          <b-collapse :id="'collapse'+data.index" @show="show(data.index)" @hidden="hidden(data.index)">
            <b-list-group-item :key="index" v-for="(item, index) in data.item.log">{{ item }}</b-list-group-item>
          </b-collapse>
        </b-list-group>
      </template>
      <template v-slot:cell(actions)="data">
        <b-button size="sm" @click="callNew(data.item.log, data.index)">
          Add log
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'
const apiUrl = 'https://logcrow.appspot.com/'
// const apiUrl = 'http://192.168.212.101:9999/'
// const apiUrl = 'http://localhost:9999/'
export default {
  name: 'AnalyzedResult',
  props: {},
  data() {
    return {
      analyzedResult: {},
      fields: [
        {key: 'index', label: 'ClusterNo.'},
        {key: 'log', label: 'Logs'},
        {key: 'actions', label: 'Actions' }
      ],
      showIndexes: [],
    }
  },
  methods: {
    makeToast(variant = null, message) {
      this.$root.$bvToast.toast(message, {
        title: `${variant || 'message'}`,
        variant: variant,
        solid: true
      })
    },
    show(index) {
      this.showIndexes.push(index)
    },
    hidden(index) {
      this.showIndexes = this.showIndexes.filter(n => n !== index);
    },
    getAnalyzedResult() {
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        currentUser.getIdToken(true).then(async (idToken) => {
          let res = await axios.get(apiUrl + 'analyzed_result', {
            headers: {
              'Authorization': `Bearer ${idToken}`,
              'Content-Type': 'application/json'
            },
            params: {
              fileID: this.$route.params.fileid
            }
          })
          this.analyzedResult = res.data
        }).catch(() => {
          this.makeToast('warning', "Failed to get uploaded file info...")
        })
      }
    },
    callNew(logs, index) {
      let sendData = ""
      if( this.showIndexes.indexOf(index) > -1 ) {
        sendData = logs.join('\n')
      } else {
        sendData = logs[0]
      }
      this.$store.commit('setNewLog', sendData)
      this.$router.push('/new')
    }
  },
  mounted: function() {
    this.getAnalyzedResult()
  }
}
</script>

<style>
.analyzedresult {
  margin: 32px;
}
.loglist {
  cursor: pointer;
  text-align: left;
}
</style>
